import React from "react";
import { SvgIcon } from "@mui/material";

const DataPipelineFlowIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      {/* Leftmost Data Source (Circle) */}
      <circle cx="4" cy="12" r="2" fill="currentColor" />
      
      {/* First Processing Block */}
      <rect x="7" y="8" width="5" height="8" rx="1" fill="currentColor" />
      
      {/* First Connecting Arrow */}
      <path d="M13 12H16L14.5 10.5M16 12L14.5 13.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      
      {/* Second Processing Block */}
      <rect x="16" y="8" width="5" height="8" rx="1" fill="currentColor" />
      
      {/* Rightmost Data Destination (Circle) */}
      <circle cx="22" cy="12" r="2" fill="currentColor" />
    </SvgIcon>
  );
};

export default DataPipelineFlowIcon;
